import store from '@/store';
import BaseClient from '../base-client';
import GlobalSearchResult, { formatGlobalSearchResult } from './model';

export default class GlobalSearchClient extends BaseClient {
  constructor(options = {}) {
    super('global-search', {
      format: formatGlobalSearchResult,
      ...options,
    });
  }

  async search({
    query, entity, first, size, order,
  }) {
    let firstP = first;
    let sizeP = size;

    if (sizeP < 0 || sizeP > 10) {
      sizeP = 10;
    }

    if (firstP > sizeP) {
      firstP = 0;
    } else if (firstP < 0) {
      firstP = 0;
    }

    try {
      const response = await this.request('get')({
        entity,
        query,
        order,
        first: firstP,
        size: sizeP,
        isUserTecnical: store.getters['session/user'].isUserTecnical,
      });
      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  }
}

export {
  GlobalSearchResult,
};
